/**
 * BudgetAlertThresholdService
 * Alert threshold configuration rows (global defaults + per-budget overrides).
 * Route: api/budget-thresholds
 */
import { CrudService } from '../base/CrudService';
/**
 * Threshold CRUD. getAll returns the global default rows; pass a budgetId via
 * getFiltered for a budget's effective set. update(id, { isActive }) toggles a row.
 */
export class BudgetAlertThresholdService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetAlertThresholdService.DEFAULT_SERVICE_PATH,
            basePath: BudgetAlertThresholdService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Threshold rows, optionally scoped to one budget (its effective set). */
    async getFiltered(budgetId) {
        const response = await this.getFilteredRaw(budgetId);
        return response.data ?? [];
    }
    getFilteredRaw(budgetId) {
        return this.http.get(this.buildUrlWithParams(undefined, { budgetId }));
    }
}
BudgetAlertThresholdService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetAlertThresholdService.BASE_PATH = 'api/budget-thresholds';
//# sourceMappingURL=BudgetAlertThresholdService.js.map